export interface Company {
  id: string;
  name: string;
}

export interface Worker {
  id: string;
  name: string;
  company: string;
}

export interface ReportTemplate {
  id: string;
  name: string;
  description: string;
  type: 'company' | 'worker';
  iconName: string;
}

export interface GeneratedReport {
  id: string;
  name: string;
  type: string;
  format: string;
  generatedBy: string;
  generatedAt: string;
  status: 'Listo' | 'Procesando';
}

export interface UnifiedMovement {
  id: string;
  date: string;
  company: string;
  worker: string;
  type: 'SPEI OUT' | 'Adelanto' | 'Dispersión Nómina';
  amount: number;
  status: 'Éxito' | 'Pendiente';
  reference: string;
}

export interface ComplianceDocument {
  id: string;
  name: string;
  company: string;
  type: 'SPEI OUT' | 'Dispersión Nómina';
  status: 'CEP';
}

export interface ScheduledReport {
  id: string;
  name: string;
  type: string;
  frequency: string;
  format: string;
  nextRun: string;
  recipients: string;
  status: 'Activo';
}

export interface ComplianceKPI {
  name: string;
  value: string;
  description: string;
  trend: 'up' | 'down' | 'neutral';
}

export interface ComplianceClient {
  id: string;
  name: string;
  description: string;
  incidentCount: number;
  status: 'high' | 'medium' | 'low';
}

export const companies: Company[] = [
  { id: '1', name: 'Todas las empresas' },
  { id: '2', name: 'Empresa Alpha Tech' },
  { id: '3', name: 'Beta Solutions' },
  { id: '4', name: 'Gamma Corp' },
  { id: '5', name: 'Construcciones del Norte SA' },
  { id: '6', name: 'Grupo Industrial ABC' },
];

export const workers: Worker[] = [
  { id: '1', name: 'Todos los trabajadores', company: 'all' },
  { id: '2', name: 'Juan Pérez Martínez', company: 'Empresa Alpha Tech' },
  { id: '3', name: 'María González López', company: 'Beta Solutions' },
  { id: '4', name: 'Carlos Rodríguez', company: 'Gamma Corp' },
  { id: '5', name: 'Ana García', company: 'Construcciones del Norte SA' },
  { id: '6', name: 'Luis Torres', company: 'Grupo Industrial ABC' },
];

export const reportTemplates: ReportTemplate[] = [
  {
    id: '1',
    name: 'Movimientos SPEI (IN/OUT)',
    description: 'Transferencias SPEI salientes y entrantes',
    type: 'company',
    iconName: 'SwapHoriz',
  },
  {
    id: '2',
    name: 'Adelantos',
    description: 'Operaciones adelanto, aprobadas y rechazadas por trabajador',
    type: 'company',
    iconName: 'TrendingUp',
  },
  {
    id: '3',
    name: 'Dispersión de Nómina',
    description: 'Por mes y por empleado',
    type: 'company',
    iconName: 'AccountBalance',
  },
  {
    id: '4',
    name: 'Historial de Adelantos',
    description: 'Adelantos solicitados, aprobados y rechazados por trabajador',
    type: 'worker',
    iconName: 'History',
  },
  {
    id: '5',
    name: 'Movimientos SPEI Personales',
    description: 'Movimientos SPEI realizados por el trabajador',
    type: 'worker',
    iconName: 'Person',
  },
  {
    id: '6',
    name: 'Estado de Cuenta',
    description: 'Balance, límites y resumen de actividad',
    type: 'worker',
    iconName: 'AccountBalanceWallet',
  },
  {
    id: '7',
    name: 'Comprobantes de Nómina',
    description: 'Recibos de nómina e información de nómina',
    type: 'worker',
    iconName: 'Receipt',
  },
];

export const generatedReports: GeneratedReport[] = [
  {
    id: '1',
    name: 'Movimientos SPEI - Diciembre 2024',
    type: 'Por Empresa',
    format: 'PDF',
    generatedBy: 'Sistema Automático',
    generatedAt: '14 de Dic 2024',
    status: 'Listo',
  },
  {
    id: '2',
    name: 'Adelantos por Trabajador',
    type: 'Por Trabajador',
    format: 'Excel',
    generatedBy: 'Juan Pérez Martínez',
    generatedAt: '14 de Dic 2024',
    status: 'Procesando',
  },
];

export const unifiedMovements: UnifiedMovement[] = [
  {
    id: '1',
    date: '2024-12-14',
    company: 'Empresa Alpha Tech',
    worker: 'Juan Pérez Martínez',
    type: 'SPEI OUT',
    amount: 15000.0,
    status: 'Éxito',
    reference: 'SPEI241214893801',
  },
  {
    id: '2',
    date: '2024-12-14',
    company: 'Beta Solutions',
    worker: 'María González López',
    type: 'Adelanto',
    amount: 3500.0,
    status: 'Pendiente',
    reference: 'ADL241214181501',
  },
  {
    id: '3',
    date: '2024-12-14',
    company: 'Gamma Corp',
    worker: '',
    type: 'Dispersión Nómina',
    amount: 280000.0,
    status: 'Éxito',
    reference: 'NOM241214118001',
  },
];

export const complianceDocuments: ComplianceDocument[] = [
  {
    id: '1',
    name: 'SPEI20241216093001',
    company: 'Empresa Alpha Tech',
    type: 'SPEI OUT',
    status: 'CEP',
  },
  {
    id: '2',
    name: 'NOM20241214110001',
    company: 'Gamma Corp',
    type: 'Dispersión Nómina',
    status: 'CEP',
  },
];

export const scheduledReports: ScheduledReport[] = [
  {
    id: '1',
    name: 'Reporte Semanal SPEI',
    type: 'Semanal',
    frequency: 'PDF',
    format: 'PDF',
    nextRun: 'Próximo envío: 2024-12-21 09:00',
    recipients: 'En 2 destinatarios',
    status: 'Activo',
  },
];

export const complianceKPIs: ComplianceKPI[] = [
  {
    name: 'Operaciones Rechazadas',
    value: '2.3%',
    description: 'Por transacciones CLASIFICADAS',
    trend: 'down',
  },
  {
    name: 'Alertas de Operación Inusual',
    value: '8',
    description: 'En las últimas 24h',
    trend: 'up',
  },
  {
    name: 'Screening Match Rate',
    value: '0.12%',
    description: 'Coincidencias en listas',
    trend: 'neutral',
  },
];

export const complianceClients: ComplianceClient[] = [
  {
    id: '1',
    name: 'Empresa Alpha Tech',
    description: 'Operaciones inusuales',
    incidentCount: 3,
    status: 'high',
  },
  {
    id: '2',
    name: 'Beta Solutions',
    description: 'Validaciones fallidas',
    incidentCount: 2,
    status: 'high',
  },
  {
    id: '3',
    name: 'Gamma Corp',
    description: 'Screening matches',
    incidentCount: 2,
    status: 'high',
  },
];
